// src/pages/auth/pages/CompanySignup.jsx
import React, { useState } from "react";
import { ReactComponent as LockIcon } from "../../../../assets/icons/lock.svg";
import { ReactComponent as CompanyIcon } from "../../../../assets/icons/building.svg";
import { ReactComponent as TaxIcon } from "../../../../assets/icons/tax.svg";
import { ReactComponent as EmailIcon } from "../../../../assets/icons/sms.svg";
import InputField from "../../components/InputFeild";
import TermsPopup from "./TermsPopup";

const CompanySignup = ({
  formData,
  handleChange,
  handleSubmit,
  errors,
  showPassword,
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  focusField,
  handleFocus,
  isLoading,
  handleBlur,
}) => {
  const [isTermsPopupOpen, setIsTermsPopupOpen] = useState(false);
  const openTermsPopup = () => setIsTermsPopupOpen(true);
  const closeTermsPopup = () => setIsTermsPopupOpen(false);
  const handleAgree = () =>
    handleChange({ target: { name: "agreedToTerms", value: true } });

  const canSubmit = formData.agreedToTerms && !isLoading;

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="w-full flex-col gap-4 animate-fade-in hidden 2xl:flex"
      >
        <InputField
          label="Tên doanh nghiệp"
          type="text"
          name="companyName"
          placeholder="Tên doanh nghiệp"
          IconComponent={CompanyIcon}
          value={formData.companyName}
          onChange={handleChange}
          error={errors.companyName}
          iconColor={focusField === "companyName" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("companyName")}
          onBlur={handleBlur}
        />
        <InputField
          label="Mã số thuế"
          type="text"
          name="tax"
          placeholder="Mã số thuế"
          IconComponent={TaxIcon}
          value={formData.tax}
          onChange={handleChange}
          error={errors.tax}
          iconColor={focusField === "tax" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("tax")}
          onBlur={handleBlur}
        />
        <InputField
          label="Email"
          type="email"
          name="email"
          placeholder="Email"
          IconComponent={EmailIcon}
          value={formData.email}
          onChange={handleChange}
          error={errors.email}
          iconColor={focusField === "email" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("email")}
          onBlur={handleBlur}
        />
        <InputField
          label="Mật khẩu"
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Mật khẩu"
          IconComponent={LockIcon}
          value={formData.password}
          onChange={handleChange}
          toggleVisibility={() => setShowPassword((prev) => !prev)}
          showPassword={showPassword}
          error={errors.password}
          iconColor={focusField === "password" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("password")}
          onBlur={handleBlur}
        />
        <InputField
          label="Nhập lại mật khẩu"
          type={showConfirmPassword ? "text" : "password"}
          name="confirmPassword"
          placeholder="Nhập lại mật khẩu"
          IconComponent={LockIcon}
          value={formData.confirmPassword}
          onChange={handleChange}
          toggleVisibility={() => setShowConfirmPassword((prev) => !prev)}
          showPassword={showConfirmPassword}
          error={errors.confirmPassword}
          iconColor={focusField === "confirmPassword" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("confirmPassword")}
          onBlur={handleBlur}
        />

        <div className="flex items-center">
          <input
            type="checkbox"
            name="agreedToTerms"
            checked={formData.agreedToTerms}
            onChange={handleChange}
            className="mr-2 accent-blue-500"
          />
          <span className="text-sm">
            Tôi đồng ý với các{" "}
            <button
              type="button"
              className="text-blue-500 hover:underline"
              onClick={openTermsPopup}
            >
              Điều khoản dịch vụ
            </button>
          </span>
          {errors.agreedToTerms && (
            <span className="text-red-500 ml-2">{errors.agreedToTerms}</span>
          )}
        </div>

        <button
          type="submit"
          disabled={!canSubmit}
          className={`w-full mt-3 font-sf-medium text-white py-3 rounded-lg transition-all ${
            canSubmit
              ? "bg-blue-500 hover:bg-blue-600 active:scale-[0.99] shadow-lg shadow-blue-500/25"
              : "bg-blue-300 cursor-default"
          }`}
        >
          <span className="inline-flex items-center justify-center gap-2">
            {isLoading && <span className="spinner" aria-hidden />}
            {isLoading ? "Đang đăng ký..." : "Đăng ký"}
          </span>
        </button>
      </form>

      {/* Mobile/Small */}
      <form
        onSubmit={handleSubmit}
        className="w-full flex-col gap-2 flex 2xl:hidden animate-fade-in"
      >
        <InputField
          type="text"
          name="companyName"
          placeholder="Tên doanh nghiệp"
          IconComponent={CompanyIcon}
          value={formData.companyName}
          onChange={handleChange}
          error={errors.companyName}
          iconColor={focusField === "companyName" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("companyName")}
          onBlur={handleBlur}
        />
        <InputField
          type="text"
          name="tax"
          placeholder="Mã số thuế"
          IconComponent={TaxIcon}
          value={formData.tax}
          onChange={handleChange}
          error={errors.tax}
          iconColor={focusField === "tax" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("tax")}
          onBlur={handleBlur}
        />
        <InputField
          type="email"
          name="email"
          placeholder="Email"
          IconComponent={EmailIcon}
          value={formData.email}
          onChange={handleChange}
          error={errors.email}
          iconColor={focusField === "email" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("email")}
          onBlur={handleBlur}
        />
        <InputField
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Mật khẩu"
          IconComponent={LockIcon}
          value={formData.password}
          onChange={handleChange}
          toggleVisibility={() => setShowPassword((prev) => !prev)}
          showPassword={showPassword}
          error={errors.password}
          iconColor={focusField === "password" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("password")}
          onBlur={handleBlur}
        />
        <InputField
          type={showConfirmPassword ? "text" : "password"}
          name="confirmPassword"
          placeholder="Nhập lại mật khẩu"
          IconComponent={LockIcon}
          value={formData.confirmPassword}
          onChange={handleChange}
          toggleVisibility={() => setShowConfirmPassword((prev) => !prev)}
          showPassword={showConfirmPassword}
          error={errors.confirmPassword}
          iconColor={focusField === "confirmPassword" ? "#1D4ED8" : "#9E9E9E"}
          onFocus={() => handleFocus("confirmPassword")}
          onBlur={handleBlur}
        />

        <div className="flex items-center">
          <input
            type="checkbox"
            name="agreedToTerms"
            checked={formData.agreedToTerms}
            onChange={handleChange}
            className="mr-2 accent-blue-500"
          />
          <span className="text-sm">
            Tôi đồng ý với các{" "}
            <button
              type="button"
              className="text-blue-500 hover:underline"
              onClick={openTermsPopup}
            >
              Điều khoản dịch vụ
            </button>
          </span>
          {errors.agreedToTerms && (
            <span className="text-red-500 ml-2">{errors.agreedToTerms}</span>
          )}
        </div>

        <button
          type="submit"
          disabled={!canSubmit}
          className={`w-full mt-3 font-sf-medium text-white py-3 rounded-lg transition-all ${
            canSubmit
              ? "bg-blue-500 hover:bg-blue-600 active:scale-[0.99] shadow-lg shadow-blue-500/25"
              : "bg-blue-300 cursor-default"
          }`}
        >
          <span className="inline-flex items-center justify-center gap-2">
            {isLoading && <span className="spinner" aria-hidden />}
            {isLoading ? "Đang đăng ký..." : "Đăng ký"}
          </span>
        </button>
      </form>

      {isTermsPopupOpen && (
        <TermsPopup onClose={closeTermsPopup} onAgree={handleAgree} />
      )}

      <style>{`
        .spinner {
          width: 16px; height: 16px; border-radius: 9999px;
          border: 2px solid rgba(255,255,255,0.6);
          border-top-color: white;
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        .animate-fade-in { animation: fadeIn .35s ease forwards; }
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
      `}</style>
    </>
  );
};

export default CompanySignup;
